export default {
  impact: 'Impact',
  repartition: 'Répartition',
  fullProperty: 'PP',
  onlyWall: 'NP',
  usufruit: 'USUFRUIT',
  legends: {
    actual: 'Situation actuelle',
    simulation: 'Simulation',
  },
}
